<template>
	<c-dialog ref="dialog" title="报工页配置" width="900" height="600" enable-flex @resolve="submit">
		<div class="flex-grow flex">
			<div class="flex-grow flex-column">
				<c-table ref="table" height="grow" :paging="false" @dataChange="updateConfig">
					<c-table-column
						label="报工字段"
						:ellipsis="false"
					>
						<template #default="{data}">
							<p class="field-name">{{data.name}}</p>
							<p class="field-remark">{{data.remark}}</p>
						</template>
					</c-table-column>

					<c-table-column
						label="字段配置"
						width="120"
						fixed-width
						:ellipsis="false"
					>
						<template #default="{data}">
							<span v-if="data.default" class="field-state">默认开启</span>
							<div v-else-if="data.switch || data.config" class="field-config flex-center-cross">
								<c-switch v-if="data.switch" v-model="data.value" :state-value="['1', '0']"></c-switch>

								<c-tooltip v-if="data.config && (!data.config.auth || data.config.auth == data.value)" ref="config" color="white" z-index="2000" click-event>
									<c-link>配置</c-link>

									<template #tip>
										<div class="field-config-box">
											<p class="field-config-name">{{data.config.name}}</p>
											<c-radio-group v-if="data.key == 'output_field_salary'" v-model="data.config.value">
												<c-radio value="0">默认</c-radio>
												<c-radio value="1">
													<span>配置公式计算</span>
													<c-link v-if="data.config.value == 1" color="main" style="margin-left: 8px; font-weight: normal;" @click.native.stop="salaryFormulaHandle">编辑公式</c-link>
												</c-radio>
											</c-radio-group>
											<c-radio-group v-else v-model="data.config.value" :options="data.config.options"></c-radio-group>
										</div>
									</template>
								</c-tooltip>
							</div>
							<c-link v-else-if="data.custom" @click="navigateTo('/custom/field/output')">前往配置</c-link>
						</template>
					</c-table-column>
				</c-table>
			</div>

			<div class="preview">
				<phone title="报工页预览">
					<div class="item">
						<p><i>*</i>生产人员</p>
						<div class="unit">
							<i class="tf-tri-down"></i>
						</div>
					</div>
					<div class="item">
						<p><i>*</i>良品数</p>
						<div class="unit"></div>
					</div>
					<div v-if="config.output_field_defects_count != '0'" class="item">
						<p>不良品数</p>
						<div class="unit"></div>
					</div>
					<div v-if="config.output_field_defects_count != '0'" class="item">
						<p>不良品项</p>
						<div class="unit">
							<i class="tf-tri-down"></i>
						</div>
					</div>

					<div class="item">
						<p>自定义字段</p>
						<div class="unit"></div>
					</div>
					
					<div v-if="config.output_field_duration != '0'" class="item">
						<p><i>*</i>报工时长</p>
						<div class="unit"></div>
					</div>
					<div v-if="config.output_field_date != '0'" class="item">
						<p><i>*</i>报工时间</p>
						<div class="unit">
							<i class="tf-tri-down"></i>
						</div>
					</div>
					
					<div v-if="config.output_field_pricing_type != '0' && config.edit_pricing_type == 1" class="item">
						<p>计价方式</p>
						<ul class="flex">
							<li>计件</li>
							<li>计时</li>
						</ul>
					</div>
					<div v-if="config.output_field_pricing_type != '0' || config.output_field_salary != '0'" class="item">
						<p>{{config.output_field_salary != '0' ? '工资绩效' : '计价方式'}}</p>
						<div class="salary">
							<span v-show="config.output_field_pricing_type != '0'">计件</span>
							<span v-show="config.output_field_salary != '0'">工资</span>
						</div>
					</div>
					
					<div v-if="config.output_field_apply_state != '0'" class="item">
						<p>审批状态</p>
						<ul class="flex">
							<li>待审核</li>
							<li>已审核</li>
						</ul>
					</div>
					<div v-if="config.output_notice == 1" class="item">
						<p>通知人员</p>
						<div class="unit">
							<i class="tf-tri-down"></i>
						</div>
					</div>
				</phone>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	import phone from '@/components/public/phone.vue'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			phone
		},

		data() {
			return {
				fieldList: [{
					name: '生产人员',
					remark: '系统默认将当前登陆员工作为当次生产人员，当登陆员工拥有代报工权限时，可以切换其他员工',
					default: 1
				}, {
					name: '良品数',
					remark: '报工时，工人填写的良品数量，良品数与不良品数不能同时为0',
					config: {
						name: '报工数自动填入',
						key: 'auto_input_fine_count',
						value: 0,
						options: [{
							name: '不自动填入',
							value: 0
						}, {
							name: '自动填入未完成数',
							value: 1
						}]
					}
				}, {
					name: '不良品数',
					remark: '开启后，工人可以填写不良品数量以及不良品项',
					switch: true,
					key: 'output_field_defects_count',
					value: '1'
				}, {
					name: '自定义字段',
					remark: '当报工拥有自定义字段时，系统将会默认展示',
					custom: true
				}, {
					name: '报工时长',
					remark: '即生产时长，工人调整报工时长，将自动计算报工开始时间',
					switch: true,
					key: 'output_field_duration',
					value: '1'
				}, {
					name: '报工时间',
					remark: '系统默认填入当前时间。开启后，工人可以自由选择报工的具体开始时间、结束时间',
					switch: true,
					key: 'output_field_date',
					value: '1'
				}, {
					name: '计价方式',
					remark: '工人可以看到自己的绩效计算方式',
					switch: true,
					key: 'output_field_pricing_type',
					value: '1',
					config: {
						auth: '1',
						name: '允许员工切换计价方式',
						key: 'edit_pricing_type',
						value: 0,
						options: [{
							name: '关闭',
							value: 0
						}, {
							name: '开启',
							value: 1
						}]
					}
				}, {
					name: '工资绩效',
					remark: '显示当前工人绩效工资单价以及当次报工预计工资',
					switch: true,
					key: 'output_field_salary',
					value: '1',
					config: {
						auth: '1',
						name: '工资计算方式',
						key: 'output_field_salary_type',
						value: 0
					}
				}, {
					name: '审批状态',
					remark: '显示当次报工的审批状态，普通工人默认待审批，如果当前报工人拥有报工审批权限时，则会自动勾选已审批',
					switch: true,
					key: 'output_field_apply_state',
					value: '1'
				}, {
					name: '通知人员',
					remark: '开启后，员工报工时，可自行指定员工发送报工通知',
					switch: true,
					key: 'output_notice',
					value: '0'
				}],
				salaryFormula: '',

				config: {}
			}
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		methods: {
			open() {
				this.fieldList.forEach(item => {
					if (item.key) {
						item.value = this.systemConfig[item.key] || item.value;
					}
					if (item.config) {
						item.config.value = this.systemConfig[item.config.key] || item.config.value;
					}
				});
				this.$refs.table.setData(this.fieldList);
				this.salaryFormula = this.systemConfig['output_field_salary_formula'] || '';
				this.$refs.dialog.open();
			},

			updateConfig(data) {
				let config = {};
				data.forEach(item => {
					if (item.key) {
						config[item.key] = item.value;
					}
					if (item.config) {
						config[item.config.key] = item.config.value;
					}
				});
				this.config = config;
			},

			salaryFormulaHandle() {
				this.$refs.config.hide();
				this.globalDialog('formulaEditor', {
					props: {
						workType: 14,
						required: true
					},
					data: {
						content: this.salaryFormula
					}
				}, content => {
					this.salaryFormula = content;
				});
			},

			submit(stop, next) {
				stop();
				let data = [];
				this.$refs.table.getData().forEach(item => {
					if (item.key) {
						data.push({
							config_item_name: `报工页字段【${item.name}】配置`,
							config_item_code: item.key,
							config_item_type: 7,
							config_item_value: item.value,
							config_item_remark: item.remark
						})
					}
					if (item.config) {
						data.push({
							config_item_name: item.config.name,
							config_item_code: item.config.key,
							config_item_type: 7,
							config_item_value: item.config.value
						})

						if (item.config.key == 'output_field_salary_type') {
							data.push({
								config_item_name: '工资计算公式',
								config_item_code: 'output_field_salary_formula',
								config_item_type: 7,
								config_item_value: item.config.value == 1 ? this.salaryFormula : ''
							})
						}
					}
				});
				this.request({
					url: '/sys_saas/set/sys/config',
					data: {
						system_config_list: data
					},
					loading: true,
					success: () => {
						this.$message({
							message: '保存成功'
						});
						next();
                        this.$store.dispatch('updateSystemConfig');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.field {
		&-name {
			font-size: 14px;
			font-weight: bold;
		}

		&-remark {
			margin-top: 4px;
			line-height: 18px;
			font-size: 12px;
			color: #999;
		}

		&-config {
			gap: 10px;

			&-box {
				width: 160px;
				padding: 10px;
			}

			&-name {
				margin-bottom: 10px;
				font-size: 14px;
				color: #666;
			}
		}

		&-state {
			color: var(--color-main);
		}
	}

	.preview {
		width: 300px;
		border-left: 1px solid var(--table-row-border);
		overflow: auto;

		>>> .m-phone {
			margin: 14px auto;
		}

		.item {
			margin: 6px 12px 0;

			&:nth-child(1) {
				margin-top: 12px;
			}

			&:nth-last-child(1) {
				margin-bottom: 24px;
			}

			p {
				line-height: 24px;
				font-size: 13px;
				color: #666;

				i {
					margin-right: .5em;
					color: #f55;
				}
			}

			.unit {
				position: relative;
				height: 30px;
				border: 1px solid #ddd;

				i {
					position: absolute;
					right: 8px;
					top: 10px;
					font-size: 10px;
				}
			}

			.salary {
				padding: 0 8px;
				overflow: hidden;
				line-height: 30px;
				font-size: 10px;
				color: #666;
				background: #F6F6F6;

				span:nth-last-child(1) {
					float: right;
				}
			}

			ul {
				gap: 6px;

				li {
					border: 1px solid #ddd;
					border-radius: 15px;
					padding: 0 16px;
					line-height: 30px;
					font-size: 12px;
					background: #F9F9F9;
				}
			}
		}
	}
</style>